// extracted by mini-css-extract-plugin
module.exports = {"receipt-counting-box":"_2N0V7VjBDa_bsvuz1dYTZU"};